import axios from "axios";
import qs from "qs";

import setting from "../../src/settings";
import encryption from "./encryption";
axios.defaults.baseURL = setting.api
//axios.defaults.baseURL = "https://" + setting.api;

axios.defaults.timeout = 30000;

// request hook
axios.interceptors.request.use(req => {
  let data = req.data;
  let encryptionUrl = encryption(setting.api, req.url, setting.CDNtoken);
  req.url = encryptionUrl.replace("https://" + setting.api, "");

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const e = data[key];
      if (data[key] === "") {
        delete data[key];
      }
    }
  }
  req.data = req.data || {};
  req.data = qs.stringify(req.data);
  return req;
});

// response hook
axios.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    return err;
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/helpers/Axios.js